const HeaderWrapperDesktop = ({ useBg = true, children }) => {
  return (
    <header
      className={`sticky top-0 left-0 right-0
        ${useBg ? "bg-white border-b border-b-gray-200" : ""} 
        flex justify-end items-center pl-6 pr-4 h-15 z-40
      `}
    >
      {children}
    </header>
  )
}

export default HeaderWrapperDesktop
